import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Documentos} from '../../models/financas/documentos/documentos';
import {FinancasService} from '@services/financas/financas.service';
import {NotificacaoService} from '@services/notificacao/notificacao.service';
import {Util} from '../../models/generico/util';
import {Subscription} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import {AnularComponent} from '../../../views/facturacao/modais/anular/anular.component';

@Component({
    selector: 'app-documentos',
    templateUrl: './documentos.component.html',
    styleUrls: ['./documentos.component.scss']
})
export class DocumentosComponent implements OnInit, OnDestroy {
    @Input() documentos: Documentos[] = [];
    private subscriptions: Subscription[] = [];
    loading = false;

    constructor(
        private _notificacao: NotificacaoService,
        private dialog: MatDialog,
        private financaService: FinancasService) {
    }

    ngOnInit(): void {
    }

    downloadPDF(documento: Documentos) {
        this.loading = true;
        this.subscriptions.push(
            (!documento.codArea ? this.financaService.getDocumentoComprasImpressao(documento.idDocumento) : this.financaService
                .getDocumentoFAImpressao(documento.idDocumento, 'A4'))
                .subscribe((res: any) => {
                        this.loading = false;
                        Util.downloadAnexo(res.objecto, documento.tipoDocumento + ' - ' + documento.codDocumento);
                    },
                    err => {
                        this.loading = false;
                        this._notificacao.notificar(err.error?.mensagem || `Falha ao fazer o download do documento "${documento.codDocumento}"`);
                    }));
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    anular(doc: Documentos) {
        const modalRef = this.dialog.open(AnularComponent, {
            minWidth: '40vw',
            data: {
                doc,
                tipo: {id: doc.idTipoDocumento, tipo: doc.tipoDocumento},
                codigo: doc.codTipoDocumento,
                idDocumento: doc.idDocumento,
                origem: 'FA'
            }
        });

        this.subscriptions.push(
            modalRef.afterClosed().subscribe(res => {
                if (!res.execucao) {
                    return;
                }
                if (res.msg) {
                    doc.codEstadoDocumento = 'A';
                    doc.estadoDocumento = 'Anulado';
                    this._notificacao.notificar(res.msg, true);
                } else {
                    this._notificacao.notificar(res.msg.mensage);
                }
            })
        );
    }
}
